<template>
  <div class="content">
    <div v-if="!showConfirmationDialog && !showCompletedDialog">
      <div class="columns">
        <div class="column is-12">
          <div class="div-table">
            <div class="columns is-gapless">
              <div class="column is-12 card-header has-text-centered button-tools">
                <strong>Add Tournament</strong>
              </div>
            </div>
            <div class="columns is-gapless">
              <div class="column is-8">
                <div
                    v-if="selectedTournamentType && selectedTournamentType.name"
                    class="field"
                >
                  <div class="control is-flex">
                    <label class="label mr-1">Tournament Type:</label>
                    <div
                        class="dropdown"
                        :class="{'is-active': tournamentTypeDropdown}"
                    >
                      <div class="dropdown-trigger">
                        <button
                            class="button is-small"
                            aria-haspopup="true"
                            aria-controls="dropdown-menu"
                            @click="tournamentTypeDropdown = !tournamentTypeDropdown"
                        >
                          <span>{{ selectedTournamentType.name }}</span>
                          <span class="icon is-small">
                            <i
                                class="far fa-angle-down"
                                aria-hidden="true"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                          class="dropdown-menu"
                          role="menu"
                      >
                        <div
                            v-for="type in tournamentTypes"
                            class="dropdown-content"
                        >
                          <a
                              class="dropdown-item"
                              @click="selectTournamentType(type)"
                          >
                            {{ type.name }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                    v-if="selectedFranchise.name"
                    class="field"
                >
                  <div class="control is-flex">
                    <label class="label mr-1">Franchise:</label>
                    <div
                        class="dropdown"
                        :class="{'is-active': franchiseDropdown}"
                    >
                      <div class="dropdown-trigger">
                        <button
                            class="button is-small"
                            aria-haspopup="true"
                            aria-controls="dropdown-menu"
                            @click="franchiseDropdown = !franchiseDropdown"
                        >
                          <span>{{ selectedFranchise.name }}</span>
                          <span class="icon is-small">
                            <i
                                class="far fa-angle-down"
                                aria-hidden="true"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                          class="dropdown-menu"
                          role="menu"
                      >
                        <div
                            v-for="franchise in franchises"
                            class="dropdown-content"
                        >
                          <a
                              class="dropdown-item"
                              @click="selectFranchise(franchise)"
                          >
                            {{ franchise.name }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                    v-if="selectedVenue && selectedVenue.name"
                    class="field"
                >
                  <div class="control is-flex">
                    <label class="label mr-1">Venue:</label>
                    <div
                        class="dropdown"
                        :class="{'is-active': venueDropdown}"
                    >
                      <div class="dropdown-trigger">
                        <button
                            class="button is-small"
                            aria-haspopup="true"
                            aria-controls="dropdown-menu"
                            @click="venueDropdown = !venueDropdown"
                        >
                          <span>{{ selectedVenue.name }}</span>
                          <span class="icon is-small">
                            <i
                                class="far fa-angle-down"
                                aria-hidden="true"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                          class="dropdown-menu"
                          role="menu"
                      >
                        <div
                            v-for="venue in venues"
                            class="dropdown-content"
                        >
                          <a
                              class="dropdown-item"
                              @click="selectVenue(venue)"
                          >
                            {{ venue.name }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                    v-if="selectedVenue && selectedVenue.id"
                    class="field"
                >
                  <div class="control is-flex">
                    <label class="label mr-1">Date:</label>
                    <date-picker
                        v-model="date"
                        placeholder="Select Date"
                    />
                  </div>
                </div>
                <hr v-if="sessions.length">
                <div
                    v-if="sessions.length"
                    class="columns"
                >
                  <div class="column is-6">
                    <div class="field">
                      <label class="label is-small">Entrants:</label>
                      <p class="control">
                        <input
                            v-model="entrants"
                            placeholder="Enter number of entrants"
                            class="input is-small"
                            type="number"
                        >
                      </p>
                    </div>
                  </div>
                  <div class="column is-6">
                    <div class="field">
                      <label class="label is-small">Headcount:</label>
                      <p class="control">
                        <input
                            v-model="headcount"
                            placeholder="Enter number of headcount"
                            class="input is-small"
                            type="number"
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                  v-if="sessions.length"
                  class="column is-4"
              >
                <div class="field">
                  <label class="label ml-4">Select session</label>
                  <div class="is-flex flex-wrap">
                    <div
                        v-for="session in sessions"
                        class="box mb-0 m-1 is-flex align-center relative"
                    >
                      <label
                          class="radio"
                          @click="selectSession(session)"
                      >
                        <input
                            type="radio"
                            :checked="session.sessionNumber == selectedSession.sessionNumber"
                            name="session_1"
                            :disabled="session.alreadyInput"
                        >
                      </label>
                      <div class="ml-4">
                        <small
                            v-if="session.alreadyInput"
                            class="is-block help-text"
                        >Already Input</small>
                        <strong class="is-size-7-touch">{{ session.readableTime }}</strong>
                        <span class="has-text-danger is-block is-size-7-touch">Session number: {{
                            session.sessionNumber
                          }}</span>
                        <span class="has-text-info is-size-7-touch">{{ session.mark }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="selectedSession.sessionNumber && !memberSearchDialog && !addNewMemberDialog"
          class="columns"
      >
        <div class="column is-12">
          <div class="div-table">
            <div class="columns is-gapless">
              <div class="column is-12 card-header has-text-centered button-tools">
                <strong>Tournament Placement</strong>
              </div>
            </div>
            <div
                v-for="(placement, index) in places"
                class="columns is-gapless relative align-center space-between"
            >
              <div class="column is-3">
                <div class="field">
                  <div class="control is-flex justify-content-center">
                    <p class="control">
                      <v-rating
                          v-model="places[index].isStarred"
                          background-color="yellow darken-1"
                          color="yellow darken-1"
                          clearable
                          length="3"
                          size="24"
                      ></v-rating>
                    </p>
                    <label class="label mr-1">{{ addSuffix(placement.place) }}</label>
                    <p class="control">
                      <input
                          v-model="places[index].ahlid"
                          class="input is-small"
                          type="text"
                          placeholder="Enter AHL number"
                          @change="getMemberInfo(places[index].ahlid, index)"
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-5">
                <div>
                  <p>{{ places[index].name }}</p>
                  <div
                      v-show="places[index].isBanned"
                      class="tag is-danger pointer"
                  >
                    Banned
                  </div>
                </div>
              </div>
              <div class="column is-4">
                <div class="field has-text-centered">
                  <label class="label">Member</label>
                  <a
                      class="button is-small"
                      @click="openMemberSearch(index)"
                  >Look Up</a>
                  <a
                      class="button is-small"
                      @click="openAddNewPlayerDialog(index)"
                  >Add New</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="selectedSession.sessionNumber && !memberSearchDialog && !addNewMemberDialog"
          class="columns"
      >
        <div class="column is-12">
          <div class="div-table">
            <div class="columns is-gapless">
              <div class="column is-12 card-header has-text-centered button-tools">
                <strong>Sign-In sheet image</strong>
              </div>
            </div>
            <div class="columns">
              <vue-dropzone
                  id="dropzone"
                  ref="tournPhoto"
                  :options="dropzoneOptions"
                  @vdropzone-success="getTournamentImageLink"
              />
              <img :src="signinsheet">
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="selectedSession.sessionNumber && !memberSearchDialog && !addNewMemberDialog"
          class="columns"
      >
        <div class="column is-12 is-flex space-between">
          <a
              class="button button-tools is-mobile"
              @click="showConfirmationDialog = true"
          >Save tournament</a>
          <!--<div>-->
          <!--<a class="btn-icon icon-shadow tooltip" data-tooltip="Delete placement" @click="deletePlace"><i class="far fa-minus"></i></a>-->
          <!--<a class="btn-icon icon-shadow tooltip" data-tooltip="Add new placement" @click="addPlace"><i class="far fa-plus"></i></a>-->
          <!--</div>-->
        </div>
      </div>


      <member-search
          v-if="memberSearchDialog"
          :token="token"
          @close="closeMemberSearchDialog"
          @addMemberId="addMemberId"
      />


      <add-new-member
          v-if="addNewMemberDialog"
          :token="token"
          @close="closeAddNewPlayerDialog"
          @addMemberId="addMemberId"
      />
    </div>
    <div v-if="showConfirmationDialog">
      <div class="modal-box">
        <v-overlay
            v-if="showLoader"
            absolute
        >
          <v-progress-circular indeterminate></v-progress-circular>
        </v-overlay>
        <header class="modal-card-head">
          <span class="modal-card-title">Please confirm the tournament data</span>
          <button
              class="delete"
              aria-label="close"
              @click="showConfirmationDialog = false"
          />
        </header>
        <section class="modal-card-body has-text-centered">
          <table
              class="table is-bordered is-striped is-hoverable is-narrow"
              style="max-width:500px;margin: 0 auto"
          >
            <thead
                class="thead"
                style="background-color:#F8F8F8"
            >
            <tr>
              <td style="border-top:0px;border-bottom:0px;border-right:0px;">
                &nbsp;
              </td>
              <td style="border:0">
                <strong>
                  Venue Name:
                </strong>
              </td>
              <td style="border:0">
                {{ selectedVenue.name }}
              </td>
            </tr>
            <tr>
              <td style="border-top:0px;border-bottom:0px;border-right:0px;">
                &nbsp;
              </td>
              <td style="border:0">
                <strong>
                  Session Time:
                </strong>
              </td>
              <td style="border:0;">
                {{ selectedSession.readableTime }}<br>
              </td>
            </tr>
            <tr>
              <td style="border-top:0px;border-bottom:0px;border-right:0px;">
                &nbsp;
              </td>
              <td style="border:0">
                <strong>
                  Date:
                </strong>
              </td>
              <td style="border:0">
                {{ this.$moment(this.date).format('MMM DD, YYYY') }}
              </td>
            </tr>
            <tr>
              <td style="border-top:0px;border-bottom:0px;border-right:0px;">
                &nbsp;
              </td>
              <td style="border:0px">
                <strong>Entrants:</strong>
              </td>
              <td style="border-left:0px;border-bottom:0px;border-top:0px">
                {{ entrants }}
              </td>
            </tr>
            <tr>
              <td style="border-top:0px;border-bottom:0px;border-right:0px;">
                &nbsp;
              </td>
              <td style="border:0px">
                <strong>Headcount:</strong>
              </td>
              <td style="border-left:0px;border-top:0px">
                {{ headcount }}
              </td>
            </tr>
            <tr>
              <td>Place</td>
              <td>AHL ID</td>
              <td>Name</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(placement, index) in places">
              <td>{{ addSuffix(placement.place) }}</td>
              <td>{{ placement.ahlid }}</td>
              <td>{{ placement.name }}</td>
            </tr>
            </tbody>
          </table>
          <br>
          <div class="field is-pulled-left">
            <div class="control">
              <a
                  type="submit"
                  class="button button-tools"
                  @click.prevent="showConfirmationDialog = false"
              >
                << Edit
              </a>
            </div>
          </div>
          <div class="field is-pulled-right">
            <div class="control">
              <a
                  type="submit"
                  class="button button-tools"
                  @click.prevent="addTournament"
              >
                Confirm >>
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div v-if="showCompletedDialog">
      <div class="modal-box">
        <header class="modal-card-head">
          <span class="modal-card-title">Success!</span>
          <button
              class="delete"
              aria-label="close"
              @click="imFinished()"
          />
        </header>
        <section class="modal-card-body has-text-centered">
          <p>
            Thank you!<br>
            Your tournament has been entered, please allow 24hrs for management approval
          </p>
          <br>
          <div class="field is-pulled-left">
            <div class="control">
              <a
                  type="submit"
                  class="button button-tools"
                  @click.prevent="addAnotherTournament()"
              >
                Add another tournament
              </a>
            </div>
          </div>
          <div class="field is-pulled-right">
            <div class="control">
              <a
                  type="submit"
                  class="button button-tools"
                  @click.prevent="imFinished()"
              >
                I'm Finished
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from '../../helpers/Datepicker.vue'
import MemberSearch from '../helpers/MemberSearch.vue'
import AddNewMember from './AddNewMember.vue'
import axios from 'axios'
import VueDropzone from 'vue2-dropzone'

export default {
  name: 'ToolsTournamentCreate',
  components: {
    DatePicker,
    MemberSearch,
    AddNewMember,
    VueDropzone
  },
  props: ['regionList', 'token', 'user'],
  data() {
    return {
      showLoader: false,
      showCompletedDialog: false,
      showConfirmationDialog: false,
      memberSearchDialog: false,
      addNewMemberDialog: false,
      places: [
        {
          place: 1,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 2,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 3,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 4,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 5,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 6,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 7,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 8,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 9,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 10,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 11,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 12,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 13,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 14,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 15,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 16,
          ahlid: '',
          name: '',
          isBanned: false
        }
      ],
      date: '',
      regionDropdown: false,
      selectedRegion: null,
      selectedTournamentType: null,
      franchises: [],
      tournamentTypes: [
        {
          'name': 'Texas Hold\'em', 'code': 'Texas_Holdem'
        }
      ],
      dropzoneOptions: {
        dictDefaultMessage: 'Click here to upload sign-in sheet photo',
        url: '//rest.ahlpoker.com/image/upload/tourn',
        thumbnailWidth: 150,
        maxFilesize: 10,
        paramName: 'file',
        acceptedFiles: 'image/*',
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560'
        },
        success: (file, res) => {
          if (file.previewElement) {
            return file.previewElement.classList.add('dz-success')
          }
          console.log(this)
          JSON.parse(res).link
        }
      },
      franchiseDropdown: false,
      selectedFranchise: [],
      venues: [],
      selectedVenue: [],
      venueDropdown: false,
      tournamentTypeDropdown: false,
      sessions: [],
      selectedSession: {},
      index: null,
      entrants: null,
      headcount: null,
      signinsheet: 0
    }
  },
  watch: {
    selectedFranchise() {
      this.getVenues()
    },
    selectedVenue() {
      this.getSessions()
    },
    date() {
      this.getSessions()
    }
  },
  created() {
    if (!this.user || !this.user.isHost) this.$router.push({name: 'FourZeroFour'})
  },
  mounted() {
    this.getFranchises()
    this.getTournamentTypes()
  },
  methods: {
    getTournamentImageLink(file, res) {
      this.signinsheet = res.link
      this.$refs.tournPhoto.removeAllFiles()
    },
    addAnotherTournament() {
      this.entrants = 0
      this.headcount = 0
      this.places = [
        {
          place: 1,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 2,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 3,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 4,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 5,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 6,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 7,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 8,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 9,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 10,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 11,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 12,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 13,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 14,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 15,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 16,
          ahlid: '',
          name: '',
          isBanned: false
        }
      ]
      this.selectedSession = {}
      this.selectedVenue = this.venues[0]
      this.date = ''
      this.showCompletedDialog = false
    },
    imFinished() {
      this.showCompletedDialog = false
      this.$router.push('/')
    },
    addSuffix(place) {
      switch (place) {
        case 1:
          return place + 'st'
        case 2:
          return place + 'nd'
        case 3:
          return place + 'rd'
        default:
          return place + 'th'
      }
    },
    addPlace() {
      this.places.push({
        place: this.places.length + 1,
        ahlid: ''
      })
    },
    deletePlace() {
      this.places.pop()
    },
    openMemberSearch(index) {
      this.index = index
      this.memberSearchDialog = true
    },
    closeMemberSearchDialog() {
      this.index = null
      this.memberSearchDialog = false
    },
    openAddNewPlayerDialog(index) {
      this.index = index
      this.addNewMemberDialog = true
    },
    closeAddNewPlayerDialog() {
      this.index = null
      this.addNewMemberDialog = false
    },
    selectRegion(region) {
      this.selectedRegion = Number(region)
      this.regionDropdown = false
    },
    selectFranchise(franchise) {
      this.selectedFranchise = franchise
      this.franchiseDropdown = false
    },
    selectVenue(venue) {
      this.selectedVenue = venue
      this.venueDropdown = false
    },
    selectTournamentType(type) {
      this.selectedTournamentType = type
      this.tournamentTypeDropdown = false
    },
    selectSession(session) {
      if (session.alreadyInput) return false
      this.selectedSession = session
    },
    getTournamentTypes() {
      let url = `admin/tournaments/gettourntypes`
      let data = {
        token: this.token
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.tournamentTypes = res.data
            this.selectedTournamentType = res.data[0]
            this.getVenues()
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          })
    },
    getFranchises() {
      this.date = ''
      this.sessions = []
      let url = `admin/tournaments/getfranchises`
      let data = {
        token: this.token
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.franchises = res.data
            this.selectedFranchise = res.data[0]
            this.getVenues()
          })
          .catch((error) => {
            this.$emit('message', {error: true,showDialog: true, message: error.response.data.message})
          })
    },
    getVenues() {
      this.sessions = []
      let url = `admin/tournaments/getvenuesforfranchise`
      let data = {
        token: this.token,
        franchise: this.selectedFranchise.id
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.venues = res.data
            this.selectedVenue = res.data[0]
            this.getSessions()
          })
          .catch((error) => {
            this.$emit('message', {error: true,showDialog: true, message: error.response.data.message})
          })
    },
    getSessions() {
      if (!this.date) return false
      let url = `admin/tournaments/getvenuesessionsfordate`
      let data = {
        token: this.token,
        venueid: this.selectedVenue.id,
        date: this.$moment(this.date).format('YYYY-MM-DD')
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.sessions = res.data
          })
          .catch((error) => {
            this.$emit('message', {error: true,showDialog: true, message: error.response.data.message})
          })
    },
    addMemberId(member) {
      this.places[this.index].ahlid = member.ahlid
      this.places[this.index].name = member.first + ' ' + member.middle + '. ' + member.last
      this.places[this.index].isBanned = member.isBanned
      this.closeMemberSearchDialog()
      this.closeAddNewPlayerDialog()
    },
    getMemberInfo(id, idx) {
      if (!id) {
        this.places[idx].ahlid = null
        this.places[idx].name = ''
        this.places[idx].isBanned = false
        return
      }
      let url = `admin/members/getmember`
      let data = {
        token: this.token,
        ahlid: id
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            console.log(res)
            if (res.data.error) {
              this.$emit('message',
                  {
                    showDialog: true,
                    error: res.data.error,
                    message: res.data.message
                  })
              this.places[idx].ahlid = ''
              this.places[idx].name = ''
              this.places[idx].isBanned = false
            } else {
              this.places[idx].ahlid = res.data.member.ahlid
              this.places[idx].name = res.data.member.name
              this.places[idx].isBanned = res.data.member.isBanned
            }
          })
          .catch((error) => {
            console.log(error.response)
          })
    },
    addTournament() {
      let url = `admin/tournaments/addtournament`
      let data = {
        token: this.token,
        franchise: this.selectedFranchise.id,
        date: this.$moment(this.date).format('YYYY-MM-DD'),
        calendarId: this.selectedSession.calendarid,
        venueID: this.selectedVenue.id,
        sessionNumber: this.selectedSession.sessionNumber,
        headcount: this.headcount,
        entrants: this.entrants,
        places: this.places,
        signinsheet: this.signinsheet,
        tournamentType: this.selectedTournamentType.code
      }
      this.showLoader = true;
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.showLoader = false;
            this.$emit('message',
                {
                  showDialog: true,
                  error: res.data.error,
                  message: res.data.message
                })
            if (!res.data.error) {
              this.clearFields()
              this.getFranchises()
              this.showConfirmationDialog = false
              this.showCompletedDialog = true
            }
          })
          .catch((error) => {
            this.showLoader = false;
            this.$emit('message',
                {
                  showDialog: true,
                  error: true,
                  message: error.response
                })
            console.log(error.response)
          })
    },
    clearFields() {
      this.selectedFranchise = []
      this.selectedVenue = []
      this.selectedSession = {}
      this.date = ''
      this.entrants = null
      this.headcount = null
      this.places = [
        {
          place: 1,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 2,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 3,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 4,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 5,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 6,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 7,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 8,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 9,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 10,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 11,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 12,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 13,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 14,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 15,
          ahlid: '',
          name: '',
          isBanned: false
        },
        {
          place: 16,
          ahlid: '',
          name: '',
          isBanned: false
        }
      ]
    }
  }
}
</script>
